import axios from 'axios';
let util = {};
var baseurl;
baseurl = "http://119.23.37.215:9099/";
//baseurl ="http://localhost:9099/";

util.ajax = axios.create({
  baseURL: baseurl + "xy/",
  timeout: 30000
});
util.picurl = baseurl + "pic/";
util.upurl = baseurl + "xy/upload/pic/";
export default util;



// WEBPACK FOOTER //
// ./src/components/axios.js